import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import store from '@/store'
import i18n from '@/plugins/i18n'
import vuetify from '@/plugins/vuetify'
import { SHARED } from '@/constants/constants'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '@/filters'
import '@/plugins/vuetify'
import './styles.scss'
import LayoutMaster from '@/components/layout/LayoutMaster.vue'
import BlankLayoutMaster from '@/components/layout/BlankLayoutMaster.vue'
import AppFormField from '@/components/FormField.vue'
import AgentAppFormField from '@/components/AgentFormField'
import AppButton from '@/components/Button.vue'
import ButtonPrimary from '@/components/ButtonPrimary.vue'
import AppDialog from '@/components/dialog.vue'
import AppDateTimePicker from '@/components/DateTimePicker.vue'
import ProfileSheet from '@/components/profileSheet.vue'
import VueClipboard from 'vue-clipboard2'
import VueAnalytics from 'vue-analytics'
import Siema from 'vue2-siema'
import OneSignalVue from 'onesignal-vue'
import Flicking from '@egjs/vue-flicking'
import VueCaptchaCode from '@johnnyguan/vue-captcha-code'
import '@egjs/vue-flicking/dist/flicking.css'

// Or, if you have to support IE9
import '@egjs/vue-flicking/dist/flicking-inline.css'

Vue.use(Flicking)
Vue.prototype.$eventHub = new Vue()
Vue.use(Siema)
Vue.use(VueClipboard)
Vue.use(VueAnalytics, {
  id: SHARED.GA_TRACKING_CODE,
  router
})
Vue.use(OneSignalVue)
Vue.use(VueCaptchaCode)
Vue.component('layout-master', LayoutMaster)
Vue.component('blank-layout-master', BlankLayoutMaster)
Vue.component('app-form-field', AppFormField)
Vue.component('agent-app-form-field', AgentAppFormField)
Vue.component('app-button', AppButton)
Vue.component('button-primary', ButtonPrimary)
Vue.component('app-dialog', AppDialog)
Vue.component('app-date-time-picker', AppDateTimePicker)
Vue.component('profile-sheet', ProfileSheet)
Vue.component('v-style', {
  render: function(createElement) {
    return createElement('style', this.$slots.default)
  }
})

Vue.config.productionTip = false
export const eventBus = new Vue()
Vue.prototype.$eventHub = new Vue()
new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App),
  beforeMount() {
    let currentDomain = window.location.hostname
    console.log('One signal currentdomain : ' + currentDomain)
    if (/\bnagad88.com\b/.test(currentDomain)) {
      this.$OneSignal.init({ appId: 'a24b6691-b0d2-4ba3-be42-e9d041752571' }).then(() => {
        console.log('app id key set successful', 'a24b6691-b0d2-4ba3-be42-e9d041752571')
      })
    }
    if (/\bnagad88.best\b/.test(currentDomain)) {
      this.$OneSignal.init({ appId: '3866f392-9698-4417-8a58-3a4d518e8b8a' }).then(() => {
        console.log('app id key set successful', '3866f392-9698-4417-8a58-3a4d518e8b8a')
      })
    }
    if (/\bbdnagad88.online\b/.test(currentDomain)) {
      this.$OneSignal.init({ appId: 'f11160ab-222d-4063-801a-cbf67208c2bc' }).then(() => {
        console.log('app id key set successful', 'f11160ab-222d-4063-801a-cbf67208c2bc')
      })
    }
    if (/\bnagad88.co\b/.test(currentDomain)) {
      this.$OneSignal.init({ appId: 'da1a02cb-f0d6-4018-b9ce-b086e4d52192' }).then(() => {
        console.log('app id key set successful', 'da1a02cb-f0d6-4018-b9ce-b086e4d52192')
      })
    }
    if (/\bnagad88.app\b/.test(currentDomain)) {
      this.$OneSignal.init({ appId: '02574c1a-e652-4a3c-9c14-fe0a816d892b' }).then(() => {
        console.log('app id key set successful', '02574c1a-e652-4a3c-9c14-fe0a816d892b')
      })
    }
    if (/\bnagad88.net\b/.test(currentDomain)) {
      this.$OneSignal.init({ appId: '8c258b1a-fecf-4faa-b74c-3b58147d0d69' }).then(() => {
        console.log('app id key set successful', '8c258b1a-fecf-4faa-b74c-3b58147d0d69')
      })
    }
    if (/\bnagad88.org\b/.test(currentDomain)) {
      this.$OneSignal.init({ appId: 'a0292173-8338-470b-8072-b4a7b97d015d' }).then(() => {
        console.log('app id key set successful', 'a0292173-8338-470b-8072-b4a7b97d015d')
      })
    }
    if (/\bnagad88.casino\b/.test(currentDomain)) {
      this.$OneSignal.init({ appId: 'a3ca5ee4-7a72-4826-b359-16890745526e' }).then(() => {
        console.log('app id key set successful', 'a3ca5ee4-7a72-4826-b359-16890745526e')
      })
    }
    if (/\bnagad88.live\b/.test(currentDomain)) {
      this.$OneSignal.init({ appId: 'acbe19d5-69e1-498b-af47-7d9b30a8c0b0' }).then(() => {
        console.log('app id key set successful', 'acbe19d5-69e1-498b-af47-7d9b30a8c0b0')
      })
    }
    if (/\bnagad88.pro\b/.test(currentDomain)) {
      this.$OneSignal.init({ appId: '88995122-d280-4b8a-b836-7851c3209065' }).then(() => {
        console.log('app id key set successful', '88995122-d280-4b8a-b836-7851c3209065')
      })
    }
    if (/\bnagad88.club\b/.test(currentDomain)) {
      this.$OneSignal.init({ appId: '2cdb7505-b0d7-463a-847c-bfac37a542c9' }).then(() => {
        console.log('app id key set successful', '2cdb7505-b0d7-463a-847c-bfac37a542c9')
      })
    }
    if (/\bnagad88.vip\b/.test(currentDomain)) {
      this.$OneSignal.init({ appId: '1cbaf394-eba5-476f-b756-1cbf1b443a5e' }).then(() => {
        console.log('app id key set successful', '1cbaf394-eba5-476f-b756-1cbf1b443a5e')
      })
    }
    if (/\bbdnagad88.net\b/.test(currentDomain)) {
      this.$OneSignal.init({ appId: '1e12aba7-430b-417c-bd03-bd66346a67bc' }).then(() => {
        console.log('app id key set successful', '1e12aba7-430b-417c-bd03-bd66346a67bc')
      })
    }
    if (/\bnagad88.company\b/.test(currentDomain)) {
      this.$OneSignal.init({ appId: 'f11160ab-222d-4063-801a-cbf67208c2bc' }).then(() => {
        console.log('app id key set successful', 'f11160ab-222d-4063-801a-cbf67208c2bc')
      })
    }
    if (/\bnagad88.exchange\b/.test(currentDomain)) {
      this.$OneSignal.init({ appId: '3f2f055f-7cd7-4bdb-a174-328f9fc3b9fd' }).then(() => {
        console.log('app id key set successful', '3f2f055f-7cd7-4bdb-a174-328f9fc3b9fd')
      })
    }
    if (/\bnagad88.io\b/.test(currentDomain)) {
      this.$OneSignal.init({ appId: '61f64eb8-ef12-48d7-a0f0-db4c2fd06373' }).then(() => {
        console.log('app id key set successful', '61f64eb8-ef12-48d7-a0f0-db4c2fd06373')
      })
    }
    if (/\bnagad88.tech\b/.test(currentDomain)) {
      this.$OneSignal.init({ appId: '6843737b-34a6-46df-8dea-12b73a1cdac7' }).then(() => {
        console.log('app id key set successful', '6843737b-34a6-46df-8dea-12b73a1cdac7')
      })
    }
    if (/\bnagad88.today\b/.test(currentDomain)) {
      this.$OneSignal.init({ appId: 'b23304b1-de19-45ec-ac4b-7467c28efc8e' }).then(() => {
        console.log('app id key set successful', 'b23304b1-de19-45ec-ac4b-7467c28efc8e')
      })
    }
  }
}).$mount('#app')
